import script from "./AddGroupsToWorkspaceLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./AddGroupsToWorkspaceLoader.vue?vue&type=script&setup=true&lang=js"

import "./AddGroupsToWorkspaceLoader.vue?vue&type=style&index=0&id=1e20d8f2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e20d8f2"]])

export default __exports__